import React, { useState } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import Container from "../../common/Container";
import Content from "../../common/Content";
import TitleDashboard from "../../common/TitleDashboard";
import TitleBanner from "../../common/TitleBanner";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10,
    color: "#fff",
  },
}));

const Banner = ({
  onOpen = () => {},
  onExit = () => {},
  title = "Test",
  ContentComponent,
  color,
}) => {
  const [expanded, setExpanded] = useState(false);
  const classes = useStyles();
  const open = async (e) => {
    try {
      await onOpen(e);
      setExpanded(!expanded);
    } catch (err) {
      console.log("Error opening", e);
    }
  };

  const exit = async (e) => {
    try {
      await onExit(e);
      setExpanded(false);
    } catch (err) {
      console.log("Error exiting", e);
    }
  };

  const renderStaticBanner = () => {
    return <TitleBanner title={title} color={color} />;
  };

  const renderInteractiveBanner = () => {
    return (
      <>
        <Backdrop
          className={classes.backdrop}
          open={expanded}
          onClick={() => setExpanded(false)}
        />
        <TitleDashboard
          title={title}
          onClick={open}
          expanded={expanded}
          color={color}
        />
        {expanded && (
          <Content exit={exit} Component={ContentComponent} color={color} />
        )}
      </>
    );
  };

  return (
    <Container
      paddingHorizontal={0}
      paddingVertical={0}
      heightFull={false}
      className="py-4"
    >
      {!ContentComponent ? renderStaticBanner() : renderInteractiveBanner()}
    </Container>
  );
};

export default Banner;
